import React from "react"
import AuthorsGrid from "../components/authors-grid"

import authorsData from "../content/authors.json"

const Authors = () => <AuthorsGrid authors={authorsData} />

export default Authors
